import Vue from 'vue';
import VueRouter from 'vue-router';
import { getModules } from '@modules';
import { AppPageNotFound } from '@/app/shared/components';

// const SCROLL_CONTAINER_ID = 'content';
// const scrollPositions = {};

// (@websanova/vue-auth): vue-router.2.x.js : Vue.router must be set

export function createRouter (config, store) {
    Vue.use(VueRouter);

    // DEFAULT ROUTES
    const appRoutes = [
        {
            path: '/error',
            name: 'page-not-found',
            component: AppPageNotFound
        },
        {
            path: '*',
            name: 'home',
            redirect: {
                name: config.FIRST_COMPONENT.name
            },
            meta: {
                auth: undefined
            }
        },
    ];

    const { routes } = getModules(store, config);
    let _routes = Object.values(routes).reduce((r,c) => r.concat(Object.values(c)), []);

    // Remover rotas com names duplicados para evitar o aviso do console "[vue-router] Duplicate named routes definition"
    const seenNames = new Set();
    _routes = _routes.filter(route => {
        if (!route.name) return true;
        if (seenNames.has(route.name)) return false;
        seenNames.add(route.name);
        return true;
    });

    // Remover names de rotas pai que possuam uma rota filha default (path: '') para evitar o aviso do console
    const removeDefaultChildNames = (routeList) => {
        routeList.forEach(route => {
            if (route.children && route.children.length > 0) {
                if (route.name && route.children.some(child => child.path === '' || child.path === '/')) {
                    delete route.name;
                }
                removeDefaultChildNames(route.children);
            }
        });
    };
    removeDefaultChildNames(_routes);

    // ex: 'My Name is {name} and my age is {age}.'
    const formatPath = (str, replacements = {}) => str.replace(
        /{(\w+)}/g,
        (placeholderWithDelimiters, placeholderWithoutDelimiters) =>
        replacements.hasOwnProperty(placeholderWithoutDelimiters) ?
        replacements[placeholderWithoutDelimiters] : placeholderWithDelimiters
    );
    const replacements = {
        ...(config.MODULES ?? []).filter((item, pos, self) => self.indexOf(item) == pos)
        .reduce((obj, val) => {
            obj[val] = val;
            return obj;
        }, {}),
        ...(config?.ROUTES_ALIAS ?? {})
    };
    _routes.map(route => {
        route.path = formatPath(route.path, replacements);
    });
    _routes = [..._routes, ...appRoutes];

    const timer = 100, _STATE = "complete";
	let interval = null;
    let enableScrollBehavior = false;

    const router = new VueRouter ({
        mode: 'hash',
        history: true,
        routes: _routes,
        scrollBehavior (to, from, savedPosition) {
            if(!enableScrollBehavior) return;
            if (to.fullPath === from.fullPath) {
                return;
            }
            if (to.hash) {
                return { selector: to.hash, behavior: "smooth" };
	        } else {
                const scrollPos = {...(savedPosition || to.meta?.scrollPos || {x: 0, y: 0}), behavior: 'smooth'};
                const isLoaded = () => (document.readyState === _STATE) && clearInterval(interval);
	            const scrollTo = () => window.scrollTo(scrollPos.x, scrollPos.y);

	            interval = setInterval(() => isLoaded() && scrollTo(), timer);
                return scrollPos;
            }
        }
    });

    router.beforeEach((to, from, next) => {
        if(enableScrollBehavior) {
            if(!from.meta?.scrollPos) {
                if(!from.meta) {
                    from.meta = {};
                }
                from.meta.scrollPos = {
                    x: 0,
                    y: 0,
                };
            }
            from.meta?.scrollPos && (from.meta.scrollPos.y = window.pageYOffset);
        }

        if(store) {
            if(from && to && (from.path.split('/')[1] != to.path.split('/')[1]
                || from.params?.appCode != to.params?.appCode)) {
                if (to.params?.title) store.dispatch("setModuleName", to.params?.title);
                // let fromModuleCode = from.params?.code;
                // if(fromModuleCode && store.hasModule(fromModuleCode)){
                //     store.unregisterModule(fromModuleCode)
                // }
            }
            store.dispatch('setNavigationRoute', to);
            store.dispatch('breadcrumbChanged', undefined);
        }
        return next();
    });
    if(store) {
        router.afterEach((to, from) => {
            let meta = to.meta || {};
            store.dispatch('breadcrumbChanged', meta.breadcrumb);
        });
    }

    if(config.routes) {
        let apiRoutes = config.routes;
        apiRoutes.forEach((_route, _idx)=> {
            const { route } = router.resolve({
                name: _route.name,
            });

            if(route){
                if(!'meta' in route){
                    route.meta = {};
                }
                if(!'breadcrumb' in route.meta){
                    route.meta.breadcrumb = undefined;
                }
                if(!'auth' in route.meta){
                    route.meta.auth = undefined;
                }
                let auth = route.meta.auth;
                let roles = auth && auth.roles ? [...auth.roles] : [];
                if(_route.permission){
                    if(!roles.includes(_route.permission)){
                        roles.splice(roles.length, 0, _route.permission);
                    }
                    if(!route.meta.auth){
                        route.meta.auth = {roles: [], redirect: {name: 'portal.login'}, forbiddenRedirect: '/portal/acesso-negado'};
                    }
                    if(!'roles' in route.meta.auth){
                        route.meta.auth.roles = [];
                    }
                    route.meta.auth.roles = roles;
                }else{
                    //auth: undefined -> Public, no checks required.
                    //auth: true -> The route requires an authenticated user.
                    //auth: false -> The route requires an un-authenticated user.
                    //auth: Array|String|Object -> The route requires authentication and will do an additional role check.
                    route.meta.auth = undefined;
                }
            }
        });
    }

    Vue.router=router;


    return router;
};